module.exports = __webpack_public_path__ + "static/media/location.baccaa38.png";